import cn from 'clsx';
import React from 'react';
import s from 'src/shared/styles/ui/Alert/Alert.module.css';

export interface AlertProps {
  message: any;
  size?: 'small' | 'normal';
  type: 'error' | 'success' | 'info';
}

const Alert: React.FC<AlertProps> = (props) => {
  const { type, size } = props;
  const rootClassName = cn(s.root, {
    [s.error]: type === 'error',
    [s.small]: size === 'small',
    [s.normal]: !size || size === 'normal',
    [s.info]: type === 'info',
  });

  return <div className={rootClassName}>{props.message}</div>;
};

export default Alert;
